/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import { useAccountUrl } from 'domain/shared/account';
import CreateAccountBreadcrumbs from 'domain/sales/account/createupdate/Create/Breadcrumbs';
import AccountForm from 'domain/sales/account/createupdate/AccountForm';
import useAccountManagementService from '../../useAccountManagementService';

const CreateAccount = () => {
  const { create, getValidationSchema } = useAccountManagementService();
  const { getListUrl } = useAccountUrl();

  return (
    <CreateForm
      submitFormFunc={create}
      initialData={{
        address: {
          country: 'United States',
        },
      }}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Account has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Account" breadcrumbs={<CreateAccountBreadcrumbs />}>
        <AccountForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateAccount;
